import { render, staticRenderFns } from "./ModelAdd.vue?vue&type=template&id=651ab15a"
import script from "./ModelAdd.vue?vue&type=script&lang=js"
export * from "./ModelAdd.vue?vue&type=script&lang=js"
import style0 from "./ModelAdd.vue?vue&type=style&index=0&id=651ab15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports